import script from "./mobile-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./mobile-detail.vue?vue&type=script&setup=true&lang=js"

import "./mobile-detail.vue?vue&type=style&index=0&id=19c9da00&lang=css"
import "./mobile-detail.vue?vue&type=style&index=1&id=19c9da00&lang=scss&scoped=true"

import exportComponent from "/home/hudson/workspace/103261_ib-gwms-customer-xc-devops/ib-gwms-customer-xc-devops/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c9da00"]])

export default __exports__